import { Agencia } from "./agencia";
import { BaseResponse } from "./base-response";

export class Usuario {
  codigo?: string;
  nombre?: string;
  cargo?: string;
  agencia?: Agencia; 
  codigoPerfil?: string;
  imei?: string;
  numeroDocumento?: string;
  rolUsuarioId?: number;
  email?: string;
  version?: string = "NR";
  uConexion?: string = "NR";
  uFuncionalidad?: string = "NR";
  canalDistribucion?: string;
}

export class FichaUsuario {
  idJwtToken?: string;
  codigo?: string;
  nombreUsuario?: string;
  codigoUsuario?: string;
  inicialesUsuario?: string;
  idAsesor?: number;
  codigoAgencia?: string;
  nombreAgencia?: string;
  idAgencia?: number;
  correoUsuario?: string; 
  codigoRol?: string;
  nombreRol?: string;
  cargo?: string;
}

export class UsuarioRegistrar {
  codigoUsuario?: string;
  correoUsuario?: string;
  nombreUsuario?: string;
  imei?: string;
  numeroDocumento?: string;
  agenciaId?: number;
  rolUsuarioId?: number;
}

export class RolUsuario {
  id?: number;
  codigo?: string;
  descripcion?: string;  
  rolAdministrativoRestringido?: boolean;
}

export class SolicitudAcceso {
  id?: number;
  codigoUsuario?: string;
  nombreAsesor?: string;
  canalDistribucion?: string;
  versionAndroid?: string;
  fechaCreacion?: string;  
  correoUsuario?: string;
  rolAsesor?: string;
  imei?: string;
  fechaActualizacion?: string;  
  motivoRechazo?: string; 
  estadoSolicitud?: string
  tieneHistorial?: boolean
}

export class UsuarioWrapper extends BaseResponse {
  fichaUsuario?: FichaUsuario;  
  listaUsuario?: Usuario [];
  listaRolUsuario?: RolUsuario [];
  listaSolicitudAcceso?: SolicitudAcceso [];  
}

export class UsuarioGraphql {
  validarAccesoWeb?: BaseResponse;
  obtenerUsuarioPorCorreo?: UsuarioWrapper; 
  obtenerAdministracionPerfil?: UsuarioWrapper; 
  obtenerRolesUsuario?: UsuarioWrapper; 
  guardarAdministracionPerfil?: UsuarioWrapper;
  eliminarAdministracionPerfil?: UsuarioWrapper;
  actualizarAdministracionPerfil?: UsuarioWrapper; 
  obtenerSolicitudAccesoPendiente?: UsuarioWrapper; 
  validarEquipoAutorizado?: BaseResponse;
  rechazarSolicitudAcceso?: BaseResponse;
  otorgarAcceso?: BaseResponse;
  obtenerHistorialSolicitud?: UsuarioWrapper; 
  reporteAdministracionPerfil?: any;
}

